import React from 'react';
import cx from 'classnames';
import propTypes from 'prop-types';
import { format, parse } from 'date-fns';
import TickIcon from '../../../icons/tick.svg';
import styles from './styles.scss';

function ShipmentEvent({ data, fontFamily, isLast }) {
  const parsedDate = parse(data.timeStamp);
  return (
    <div className={styles.trackingComponentItem}>
      <div className={styles.trackingComponentImageLineContainer}>
        <div className={styles.trackingComponentImage}>
          <div className={styles.tickIcon}><TickIcon /></div>
        </div>
        {!isLast && (
          <hr className={cx(styles.tickLine, styles.tickDashedLine)} />
        )}
      </div>
      <div className={styles.trackingDetails}>
        <div className={styles.trackingDetailsInfo}>
          <div style={fontFamily}>{data.state}</div>
        </div>
        <div className={styles.trackingDetailsTimes}>
          <div id="tracking_data_time" style={fontFamily} className={styles.trackingDateTime}>
            {format(parsedDate, 'MMM DD')} {format(parsedDate, 'HH:mm a')}
          </div>
        </div>
      </div>
    </div>
  );
}

ShipmentEvent.propTypes = {
  data: propTypes.shape({
    timeStamp: propTypes.string,
    state: propTypes.string,
  }),
  fontFamily: propTypes.shape({
    fontFamily: propTypes.string,
  }),
};

ShipmentEvent.defaultProps = {
  data: {},
  fontFamily: {},
};

export default ShipmentEvent;
